import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'
import type { ChangePasswordRequest } from '~/types/apis/changePassword'
import type {
  CheckRegistrationRequest,
  CheckRegistrationResponse
} from '~/types/apis/checkRegistration'
import type {
  ForgotPasswordRequest,
  ForgotPasswordResponse
} from '~/types/apis/forgotPassword'
import type { LoginRequest, LoginResponse } from '~/types/apis/login'
import type { RegisterRequest, RegisterResponse } from '~/types/apis/register'

import type {
  SetNewPasswordRequest,
  SetNewPasswordResponse
} from '~/types/apis/setNewPassword'
import type {
  SocialLoginRequest,
  SocialLoginResponse
} from '~/types/apis/socialLogin'
import type {
  VerifyRegisterOtpRequest,
  VerifyRegisterOtpResponse
} from '~/types/apis/verifyRegisterOtp'

export const authRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async checkRegistration(
    options: FetchOptions & { body?: CheckRegistrationRequest } = {}
  ): Promise<CheckRegistrationResponse> {
    return fetch<CheckRegistrationResponse>('/v1/storefront/check-email', {
      ...options,
      method: 'POST'
    })
  },
  async login(
    options: FetchOptions & { body?: LoginRequest } = {}
  ): Promise<LoginResponse> {
    return fetch<LoginResponse>('/v1/storefront/login', {
      ...options,
      method: 'POST'
    })
  },
  async socialLogin(
    options: FetchOptions & { body?: SocialLoginRequest } = {}
  ): Promise<SocialLoginResponse> {
    return fetch<SocialLoginResponse>('/v1/storefront/auth/login-social', {
      ...options,
      method: 'POST'
    })
  },
  async forgotPassword(
    options: FetchOptions & { body?: ForgotPasswordRequest } = {}
  ): Promise<ForgotPasswordResponse> {
    return fetch<ForgotPasswordResponse>('/v1/storefront/forgot-password', {
      ...options,
      method: 'POST'
    })
  },
  async setNewPassword(
    token: string,
    options: FetchOptions & { body?: SetNewPasswordRequest } = {}
  ): Promise<SetNewPasswordResponse> {
    return fetch<SetNewPasswordResponse>('/v1/storefront/change-password', {
      ...options,
      headers: { ...options.headers, Authorization: `Bearer ${token}` },
      method: 'POST'
    })
  },
  async verifyRegisterOtp(
    token: string,
    options: FetchOptions & { body?: VerifyRegisterOtpRequest } = {}
  ): Promise<RegisterResponse> {
    return fetch<VerifyRegisterOtpResponse>('/v1/storefront/verify-sms', {
      ...options,
      headers: { ...options.headers, Authorization: `Bearer ${token}` },
      method: 'POST'
    })
  },
  async register(
    token: string,
    options: FetchOptions & { body?: RegisterRequest } = {}
  ): Promise<RegisterResponse> {
    return fetch<RegisterResponse>('/v1/storefront/create-user', {
      ...options,
      headers: { ...options.headers, Authorization: `Bearer ${token}` },
      method: 'POST'
    })
  },
  async changePassword(
    options: FetchOptions & { body?: ChangePasswordRequest } = {}
  ): Promise<ChangePasswordResponse> {
    return fetch<ChangePasswordResponse>(
      '/v1/storefront/customer/edit/change-password',
      {
        ...options,
        method: 'POST'
      }
    )
  }
})
